import api from "config/axios";

export const getGenders = () => api.get("/genders");
